import { useState } from 'react';
import {
  Box,
  Chip,
  Select, MenuItem
} from '@mui/material';
import { North, South, ElectricBolt } from "@mui/icons-material";
import ExpandableSearch from './expanadbleSearch';

const Filter = ({getData}) => {
	const [productGroup, setProductGroup] = useState([]);
	const [saleType, setSaleType] = useState([]);
	const [sorting, setSorting] = useState('0');
	const [search, setSearch] = useState('');

	const onSelectProductGroup=(value)=>{
		let pg = [...productGroup];
		if(pg.includes(value))
			pg = pg.filter(f=>f!=value);
		else
			pg.push(value);

		setProductGroup(pg);

		getData({productGroup: pg, saleType: saleType, sorting: sorting, search: search});
	}

	const onSelectSaleType=(value)=>{
		let st = [...saleType];
		if(st.includes(value))
			st = st.filter(f=>f!=value);
		else
			st.push(value);

		setSaleType(st);

		getData({productGroup: productGroup, saleType: st, sorting: sorting, search: search});
	}

	const onChangeSorting=(value)=>{
		setSorting(value);

		getData({productGroup: productGroup, saleType: saleType, sorting: value, search: search});
	}

	const handleSearch = (value) => {
		setSearch(value);
    getData({productGroup: productGroup, saleType: saleType, sorting: sorting, search: value});
  };

  return (
    <Box sx={{p: 1}}>
			<Chip
				key={'ao'}
				label={"Áo"}
				variant="outlined"
				sx={{
					minWidth: 50,
					textAlign: "center",
					bgcolor: productGroup.includes("Bra") ? "cyan" : "transparent",
					cursor: 'pointer',
					mr: 1
				}}
				onClick={()=>onSelectProductGroup("Bra")}
			/>
			<Chip
				key={'quan'}
				label={"Quần"}
				variant="outlined"
				sx={{
					minWidth: 50,
					textAlign: "center",
					bgcolor: productGroup.includes("Brief") ? "cyan" : "transparent",
					cursor: 'pointer',
					mr: 1
				}}
				onClick={()=>onSelectProductGroup("Brief")}
			/>
			<Chip
				key={'discount'}
				label={"Khuyến mãi"}
				variant="outlined"
				sx={{
					minWidth: 50,
					textAlign: "center",
					bgcolor: saleType.includes("discount") ? "cyan" : "transparent",
					cursor: 'pointer',
					mr: 1
				}}
				onClick={()=>onSelectSaleType("discount")}
			/>
			<Chip
				key={'normal'}
				label={"Nguyên giá"}
				variant="outlined"
				sx={{
					minWidth: 50,
					textAlign: "center",
					bgcolor: saleType.includes("normal") ? "cyan" : "transparent",
					cursor: 'pointer',
					mr: 1
				}}
				onClick={()=>onSelectSaleType("normal")}
			/>
			<Chip
				key={'bargain'}
				label={"Bargain"}
				variant="outlined"
				sx={{
					minWidth: 50,
					textAlign: "center",
					bgcolor: saleType.includes("bargain") ? "cyan" : "transparent",
					cursor: 'pointer',
					mr: 1
				}}
				onClick={()=>onSelectSaleType("bargain")}
			/>
			<Select size="small"
        value={sorting}
        label=""
        onChange={(e)=>onChangeSorting(e.target.value)}
				sx={{height: '30.4px', borderRadius: '15px', fontSize: '0.8125rem', marginRight: 1}}
      >
        <MenuItem value={'0'}>
          <em>Sắp xếp mặc định</em>
        </MenuItem>
				<MenuItem value={'bestsaler'}><ElectricBolt sx={{fontSize: '0.8125rem'}}/>&nbsp; SP Bán chạy</MenuItem>
        <MenuItem value={'priceasc'}><North sx={{fontSize: '0.8125rem'}}/>&nbsp; Giá tăng dần</MenuItem>
        <MenuItem value={'pricedesc'}><South sx={{fontSize: '0.8125rem'}}/>&nbsp; Giá giảm dần</MenuItem>
      </Select>
			<ExpandableSearch onSearch={handleSearch} search={search} placeholder="Tìm sản phẩm..." />
		</Box>
  );
};

export default Filter;
